import type { Template } from "@/types";

export const LA_04_H4_V0: Template[] = [
    {
        id: "la-04-h4v0-01",
        name: "LA 01 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 152, width: 332, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 340, y: 152, width: 332, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 152, width: 332, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1020, y: 152, width: 332, height: 236, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-02",
        name: "LA 02 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 49, y: 46, width: 312, height: 221, rotation: 0, imageRotation: 0 },
            { id: "2", x: 361, y: 276, width: 312, height: 220, rotation: 0, imageRotation: 0 },        
            { id: "3", x: 681, y: 276, width: 311, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 992, y: 46, width: 311, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-03",
        name: "LA 03 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 168, y: 53, width: 340, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 168, y: 275, width: 340, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 844, y: 53, width: 340, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 844, y: 275, width: 340, height: 213, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-04",
        name: "LA 04 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 42, y: 258, width: 293, height: 209, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 258, width: 293, height: 209, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 258, width: 293, height: 209, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1023, y: 258, width: 293, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-05",
        name: "LA 05 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 243, width: 332, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 340, y: 243, width: 332, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 243, width: 332, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1020, y: 243, width: 332, height: 236, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-06",
        name: "LA 06 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 47, y: 53, width: 304, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 274, width: 304, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1001, y: 53, width: 304, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1001, y: 274, width: 304, height: 214, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-07",
        name: "LA 07 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 42, y: 74, width: 293, height: 209, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 74, width: 293, height: 209, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 74, width: 293, height: 209, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1023, y: 74, width: 293, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-08",
        name: "LA 08 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_08.png",
        size: [1352, 541],
        style: {},
        slots: [      
            { id: "1", x: 221, y: 41, width: 233, height: 148, rotation: 0, imageRotation: 0 },
            { id: "2", x: 221, y: 197, width: 233, height: 147, rotation: 0, imageRotation: 0 },
            { id: "3", x: 221, y: 352, width: 233, height: 147, rotation: 0, imageRotation: 0 },
            { id: "4", x: 738, y: 74, width: 552, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-09",
        name: "LA 09 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 103, y: 218, width: 450, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 103, y: 54, width: 221, height: 157, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 54, width: 221, height: 157, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 76, width: 591, height: 389, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h4v0-10",
        name: "LA 10 - H4V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h4_v0_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 46, y: 52, width: 684, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1074, y: 52, width: 229, height: 140, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1074, y: 200, width: 229, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1074, y: 348, width: 229, height: 139, rotation: 0, imageRotation: 0 }
        ],
    }
];